module.exports = (parcelRequire.load("6mypk")).then(() => parcelRequire('cp7HX'));